import { JSX } from 'react';
import { GameId } from '@bg-shared';
import { FeatureLabel } from '@bg-components/FeatureLabel';
import classNames from 'classnames';
import classes from './NonLiveLabel.module.scss';

interface IProps {
    gameId: GameId;
    className?: string;
    dataQa?: string;
}

export const NonLiveLabel = (props: IProps): JSX.Element => {
    if (_featuresConfig?.showNonLiveLabel?.includes(props.gameId)) {
        return (
            <FeatureLabel
                dataQa={props.dataQa}
                className={classNames(classes.label, props.className)}
            >
                NON-LIVE
            </FeatureLabel>
        );
    }

    return null;
};
